import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
    key: 2,
    class: "mg-chat-button"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
import { ref, computed, watch, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ChatMgButton from './ChatMgButton.vue';
import MGButton from './MGButton.vue';
import MGDialog from './MGDialog.vue';
import { useDarkMode } from '@/composables/useDarkMode';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HeaderBlock',
    props: {
        title: {},
        color: {},
        bgcolor: {},
        darkBgcolor: {},
        border: { type: [Number, Boolean, String], default: 1 },
        edit: { type: Boolean },
        del: { type: Boolean },
        info: { type: Boolean },
        download: { type: Boolean },
        deleteOnly: { type: Boolean },
        share: { type: Boolean },
        menuTitle: { default: 'Options' },
        menuDescription: {},
        menuEditLabel: { default: 'Edit' },
        menuDeleteLabel: { default: 'Delete' },
        logicalBack: { type: Boolean },
        backButton: { type: Boolean },
        transparent: { type: Boolean },
        overlay: { type: Boolean },
        colourMode: {},
        notificationCount: {}
    },
    emits: ["delete", "edit", "info", "back", "logicalBack", "whatsapp", "download"],
    setup(__props, { emit: __emit }) {
        const { isDarkMode } = useDarkMode();
        const props = __props;
        const emit = __emit;
        const route = useRoute();
        const router = useRouter();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const escapeRoute = ref(null);
        const allowBack = ref(false);
        const showDelete = ref(false);
        const showEditDeleteMenu = ref(false);
        const deleting = ref(false);
        const favoritesIcon = ref(false);
        const mgChat = ref(false);
        const settingsMenu = ref(false);
        const voucherIcon = ref(false);
        const whatsappIcon = ref(false);
        const addButton = ref(false);
        const notificationsIcon = ref(false);
        const safeTop = computed(() => {
            return parseInt(cookies?.get('st') ?? '0');
        });
        const headerHeight = computed(() => {
            return 56 + safeTop.value;
        });
        const headerPadding = computed(() => {
            return 4 + safeTop.value;
        });
        // True once the window has scrolled past a small threshold — drives the
        // overlay variant's transparent -> gradient+blur transition.
        const scrolled = ref(false);
        function onScroll() {
            scrolled.value = window.scrollY > 12;
        }
        // Height/padding are always applied inline. For the overlay variant the
        // background + border are owned by the .overlay CSS classes (so the gradient
        // can fade in on scroll), so we skip them here.
        const headerStyle = computed(() => {
            const base = `height: ${headerHeight.value}px; padding-top: ${headerPadding.value}px;`;
            if (props.overlay)
                return base;
            const bg = isDarkMode.value ? (props.darkBgcolor ?? '#2a2540') : (props.bgcolor ?? 'var(--header-bg-color)');
            const borderBottom = `border-bottom: ${props.border === false ? 0 : props.border}px solid var(--header-border-color);`;
            const transparentStyle = props.transparent ? 'background-color: transparent; border-bottom: none;' : '';
            return `${base} background-color: ${bg}; ${borderBottom}${transparentStyle}`;
        });
        const rightColIcons = computed(() => {
            const icons = [];
            if (notificationsIcon.value) {
                icons.push({ type: 'notifications' });
            }
            if (settingsMenu.value) {
                icons.push({ type: 'settings' });
            }
            if (favoritesIcon.value) {
                icons.push({ type: 'favorites' });
            }
            if (voucherIcon.value) {
                icons.push({ type: 'voucher' });
            }
            if (addButton.value) {
                icons.push({ type: 'add' });
            }
            if (whatsappIcon.value) {
                icons.push({ type: 'whatsapp' });
            }
            if (escapeRoute.value && !route.query.inModal) {
                icons.push({ type: 'close' });
            }
            if (props.share) {
                icons.push({ type: 'share' });
            }
            if (props.download) {
                icons.push({ type: 'download' });
            }
            if (props.edit && props.del) {
                icons.push({ type: 'menu-edit-delete' });
            }
            else if (props.edit) {
                icons.push({ type: 'edit' });
            }
            else if (props.del) {
                icons.push({ type: 'delete' });
            }
            if (mgChat.value && !escapeRoute.value) {
                icons.push({ type: 'chat', prompt: typeof mgChat.value === 'string' ? mgChat.value : undefined });
            }
            return icons;
        });
        function onLoad() {
            settingsMenu.value = route.meta.showSettings;
            voucherIcon.value = route.meta.showVoucherIcon;
            whatsappIcon.value = route.meta.showWhatsappIcon;
            favoritesIcon.value = route.meta.showFavoritesIcon;
            mgChat.value = route.meta.aiChat ?? false;
            escapeRoute.value = route.meta.escapeRoute;
            if (escapeRoute.value == null || escapeRoute.value == undefined) {
                escapeRoute.value = route.query.escapeRoute;
            }
            allowBack.value = route.meta.allowBack ?? true;
            addButton.value = route.meta.addButton ?? false;
            notificationsIcon.value = route.meta.showNotifications ?? false;
        }
        // history.state.back is null on a deep link (no in-app history to go back to)
        function goBackOrHome() {
            if (router.options.history.state.back)
                router.back();
            else
                router.push({ path: '/', replace: true });
        }
        function goEscape() {
            if (escapeRoute.value == '<')
                goBackOrHome();
            else
                router.push({ path: '/' + escapeRoute.value, replace: true });
        }
        function onEditPressed() {
            emit('edit');
            if (props.edit && typeof props.edit === 'string') {
                router.push(props.edit);
            }
        }
        function handleBack() {
            if (route.meta.overrideBack) {
                router.push(route.meta.overrideBack);
            }
            else {
                goBackOrHome();
            }
        }
        function handleLogicalBack() {
            emit('logicalBack');
        }
        async function handleShare() {
            const shareData = {
                title: 'Syso',
                text: 'Check out Syso',
                url: window.location.origin,
            };
            try {
                if (navigator.share) {
                    await navigator.share(shareData);
                }
                else {
                    await navigator.clipboard.writeText(shareData.url);
                }
            }
            catch (err) {
                // Ignore the user cancelling the share sheet
                if (err.name !== 'AbortError') {
                    console.error('Share failed', err);
                }
            }
        }
        function handleDelete() {
            deleting.value = true;
            emit('delete', () => {
                showDelete.value = false;
            });
        }
        watch(showDelete, (newVal) => {
            if (!newVal) {
                deleting.value = false;
            }
        });
        onMounted(() => {
            onLoad();
            // Attach unconditionally: `overlay` can flip to true after mount (e.g. when a
            // page drills into a sub-view), and a listener added only when overlay was
            // true at mount would never fire. It just maintains the `scrolled` ref, which
            // is a no-op when not in overlay mode.
            onScroll();
            window.addEventListener('scroll', onScroll, { passive: true });
        });
        onUnmounted(() => {
            window.removeEventListener('scroll', onScroll);
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_v_row, {
                    class: _normalizeClass(["headerBlock", { dark: _unref(isDarkMode), overlay: _ctx.overlay, scrolled: _ctx.overlay && scrolled.value }]),
                    style: _normalizeStyle(headerStyle.value)
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "left-col v-col-2" }, {
                            default: _withCtx(() => [
                                (allowBack.value && !escapeRoute.value && !_ctx.logicalBack)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "mg-circle-icon-button",
                                        onClick: _cache[0] || (_cache[0] = ($event) => { handleBack(); })
                                    }, [
                                        _createElementVNode("img", {
                                            src: require('@/assets/L-Arrow-24px.svg'),
                                            alt: "Back",
                                            class: _normalizeClass(['back-arrow-icon', { 'white-arrow': _ctx.color === 'white' }])
                                        }, null, 10, _hoisted_1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (allowBack.value && !escapeRoute.value && _ctx.logicalBack)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "mg-circle-icon-button",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (handleLogicalBack()))
                                    }, [
                                        _createElementVNode("img", {
                                            src: require('@/assets/L-Arrow-24px.svg'),
                                            alt: "Back",
                                            class: _normalizeClass(['back-arrow-icon', { 'white-arrow': _ctx.color === 'white' }])
                                        }, null, 10, _hoisted_2)
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.backButton)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        class: "mg-circle-icon-button",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (emit('back')))
                                    }, [
                                        _createElementVNode("img", {
                                            src: require('@/assets/L-Arrow-24px.svg'),
                                            alt: "Back",
                                            class: _normalizeClass(['back-arrow-icon', { 'white-arrow': _ctx.color === 'white' }])
                                        }, null, 10, _hoisted_3)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_col, {
                            class: "title",
                            style: _normalizeStyle('color: ' + (_ctx.color ?? 'var(--header-text-color)'))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.title), 1),
                                (_ctx.info)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: require('@/assets/i.png'),
                                        alt: "Info",
                                        class: "title-info-icon",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (emit('info')))
                                    }, null, 8, _hoisted_4))
                                    : _createCommentVNode("", true),
                                _renderSlot(_ctx.$slots, "default")
                            ]),
                            _: 3
                        }, 8, ["style"]),
                        _createVNode(_component_v_col, { class: "right-col v-col-2" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["right-col-icons", { 'single-icon': rightColIcons.value.length === 1 }])
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightColIcons.value, (icon) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: icon.type
                                        }, [
                                            (icon.type === 'notifications')
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "notification-bell-wrapper",
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (_unref(router).push('/allnotifications')))
                                                }, [
                                                    _createElementVNode("img", {
                                                        class: "mg-circle-image-button",
                                                        src: require('@/assets/notificationbell.png')
                                                    }, null, 8, _hoisted_5)
                                                ]))
                                                : (icon.type === 'settings')
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 1,
                                                        class: "mg-circle-icon-button",
                                                        onClick: _cache[5] || (_cache[5] = ($event) => (_unref(router).push('/settings')))
                                                    }, [
                                                        _createElementVNode("img", {
                                                            src: require('@/assets/settingscog.png'),
                                                            alt: "Settings",
                                                            class: "menu-icon"
                                                        }, null, 8, _hoisted_6)
                                                    ]))
                                                    : (icon.type === 'chat')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                            _createVNode(ChatMgButton, {
                                                                prompt: icon.prompt,
                                                                hover: false
                                                            }, null, 8, ["prompt"])
                                                        ]))
                                                        : (icon.type === 'favorites')
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 3,
                                                                class: "mg-circle-image-button favorites-icon",
                                                                src: require('@/assets/heart.png'),
                                                                onClick: _cache[6] || (_cache[6] = ($event) => (_unref(router).push('/FavoriteVouchers')))
                                                            }, null, 8, _hoisted_8))
                                                            : (icon.type === 'voucher')
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 4,
                                                                    class: "mg-circle-image-button",
                                                                    src: require('@/assets/Wallet-24px.svg'),
                                                                    onClick: _cache[7] || (_cache[7] = ($event) => (_unref(router).push('/Wallet')))
                                                                }, null, 8, _hoisted_9))
                                                                : (icon.type === 'add')
                                                                    ? (_openBlock(), _createElementBlock("img", {
                                                                        key: 5,
                                                                        class: "mg-circle-image-button keep-colour",
                                                                        src: require('@/assets/plus-inverted.png'),
                                                                        onClick: _cache[8] || (_cache[8] = ($event) => (_unref(router).push('/shopvouchers')))
                                                                    }, null, 8, _hoisted_10))
                                                                    : (icon.type === 'whatsapp')
                                                                        ? (_openBlock(), _createElementBlock("img", {
                                                                            key: 6,
                                                                            class: "mg-circle-image-button keep-colour",
                                                                            src: require('@/assets/whatsappicon.png'),
                                                                            alt: "WhatsApp",
                                                                            onClick: _cache[9] || (_cache[9] = ($event) => (emit('whatsapp')))
                                                                        }, null, 8, _hoisted_11))
                                                                        : (icon.type === 'close')
                                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                                key: 7,
                                                                                class: "mg-circle-icon-button",
                                                                                onClick: goEscape
                                                                            }, [
                                                                                _createElementVNode("img", {
                                                                                    src: require('@/assets/close-24px.svg'),
                                                                                    alt: "Close",
                                                                                    class: _normalizeClass(['close-icon', { 'white-arrow': _ctx.color === 'white' }])
                                                                                }, null, 10, _hoisted_12)
                                                                            ]))
                                                                            : (icon.type === 'share')
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 8,
                                                                                    class: "mg-circle-icon-button",
                                                                                    onClick: handleShare
                                                                                }, [
                                                                                    _createVNode(_component_v_icon, { icon: "mdi-share-variant" })
                                                                                ]))
                                                                                : (icon.type === 'edit')
                                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                                        key: 9,
                                                                                        class: "mg-circle-icon-button",
                                                                                        onClick: onEditPressed
                                                                                    }, [
                                                                                        _createVNode(_component_v_icon, { icon: "mdi-pencil" })
                                                                                    ]))
                                                                                    : (icon.type === 'delete')
                                                                                        ? (_openBlock(), _createElementBlock("div", {
                                                                                            key: 10,
                                                                                            class: "mg-circle-icon-button",
                                                                                            onClick: _cache[10] || (_cache[10] = ($event) => (showDelete.value = true))
                                                                                        }, [
                                                                                            _createVNode(_component_v_icon, { icon: "mdi-delete" })
                                                                                        ]))
                                                                                        : (icon.type === 'download')
                                                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                                                key: 11,
                                                                                                class: "mg-circle-icon-button",
                                                                                                onClick: _cache[11] || (_cache[11] = ($event) => (emit('download')))
                                                                                            }, [
                                                                                                _createElementVNode("img", {
                                                                                                    src: require('@/assets/document.png'),
                                                                                                    alt: "Generate report",
                                                                                                    class: "menu-icon"
                                                                                                }, null, 8, _hoisted_13)
                                                                                            ]))
                                                                                            : (icon.type === 'menu-edit-delete')
                                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                                    key: 12,
                                                                                                    class: "mg-circle-icon-button",
                                                                                                    onClick: _cache[12] || (_cache[12] = ($event) => (showEditDeleteMenu.value = true))
                                                                                                }, [
                                                                                                    _createElementVNode("img", {
                                                                                                        src: require('@/assets/Menu.png'),
                                                                                                        alt: "Menu",
                                                                                                        class: "menu-icon menu-dots"
                                                                                                    }, null, 8, _hoisted_14)
                                                                                                ]))
                                                                                                : _createCommentVNode("", true)
                                        ], 64));
                                    }), 128))
                                ], 2)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 3
                }, 8, ["class", "style"]),
                _createVNode(MGDialog, {
                    modelValue: showEditDeleteMenu.value,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((showEditDeleteMenu).value = $event)),
                    title: _ctx.menuTitle,
                    maxWidth: "500px",
                    contentHeight: "auto"
                }, {
                    actions: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_ctx.menuDescription), 1),
                        (!_ctx.deleteOnly)
                            ? (_openBlock(), _createBlock(MGButton, {
                                key: 0,
                                fullWidth: true,
                                onClick: _cache[13] || (_cache[13] = ($event) => { showEditDeleteMenu.value = false; onEditPressed(); }),
                                text: _ctx.menuEditLabel
                            }, null, 8, ["text"]))
                            : _createCommentVNode("", true),
                        _createVNode(MGButton, {
                            stacked: _ctx.deleteOnly ? false : true,
                            fullWidth: true,
                            onClick: _cache[14] || (_cache[14] = ($event) => { showEditDeleteMenu.value = false; showDelete.value = true; }),
                            text: _ctx.menuDeleteLabel
                        }, null, 8, ["stacked", "text"]),
                        _createVNode(MGButton, {
                            stacked: true,
                            fullWidth: true,
                            onClick: _cache[15] || (_cache[15] = ($event) => (showEditDeleteMenu.value = false)),
                            outline: true,
                            text: "Cancel"
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"]),
                _createVNode(MGDialog, {
                    modelValue: showDelete.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((showDelete).value = $event)),
                    title: "Delete",
                    maxWidth: "500px",
                    contentHeight: "auto"
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", null, "Are you sure you want to delete \"" + _toDisplayString(_ctx.title) + "\"?", 1)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            fullWidth: true,
                            onClick: handleDelete,
                            text: deleting.value ? 'Deleting...' : 'Delete',
                            disabled: deleting.value
                        }, null, 8, ["text", "disabled"]),
                        _createVNode(MGButton, {
                            stacked: true,
                            fullWidth: true,
                            onClick: _cache[17] || (_cache[17] = ($event) => (showDelete.value = false)),
                            outline: true,
                            text: "Cancel",
                            disabled: deleting.value
                        }, null, 8, ["disabled"])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
